import SideDrawer from './SideDrawer.component';

export default SideDrawer;